import React from 'react';
import { grey } from '@mui/material/colors';
import { AddCircle } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';

interface Props {
  title: string;
  onAdd: VoidFunction;
}

export const groupHeaderCellStyles: React.CSSProperties = {
  width: '100%',
  minHeight: 'auto',
  padding: '0.3rem 0.5rem',
  backgroundColor: grey[100],
  borderBottom: `1px solid ${grey[300]}`,
};

export const GroupHeader = ({ title, onAdd }: Props) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap="1rem" width="100%">
    <Typography variant="subtitle2">{title}</Typography>

    <Button size="small" startIcon={<AddCircle fontSize="small" />} onClick={onAdd}>
      Add line item
    </Button>
  </Stack>
);
